// import React from 'react';
// import { Box, Button, Grid, Typography } from "@mui/material";
// import MloSearchLady from "../../assets/borrower-page/MLOSearchLady.svg";
// import { useNavigate } from "react-router-dom";

// export default function SearchMLO() {
//     const router = useNavigate();
//     return (
//         <Grid container justifyContent="center" spacing={2}>
//             <Grid item xs={11} md={11} lg={11} ml={2} mr={2}>
//                 <Box
//                     style={{
//                         backgroundImage: `url(${MloSearchLady})`,
//                         backgroundRepeat: 'no-repeat',
//                         backgroundSize: 'contain',
//                         backgroundPosition: 'center',
//                         minHeight: '100vh',
//                         display: 'flex',
//                         alignItems: 'center',
//                         padding: '6rem',
//                         color: '#FFFFFF'
//                     }}
//                 >


//                     <Grid md={1}>


//                     </Grid>
//                     <Grid container justifyContent="flex-end" alignItems="center">
//                         <Grid
//                             item
//                             xs={12}
//                             md={6}
//                             textAlign={{ xs: "center", md: "left" }}
//                         // style={{ padding: '1rem' }} // optional for better text visibility
//                         >
//                             <Typography
//                                 mb={0}
//                                 fontWeight={700}
//                                 fontSize={32}
//                                 lineHeight={"48px"}
//                                 color="#FFFFFF"
//                             >
//                                 Searching for MLOs Near You?
//                             </Typography>
//                             <Typography
//                                 mb={2}
//                                 fontWeight={700}
//                                 fontSize={32}
//                                 lineHeight={"48px"}
//                                 color="#FFFFFF"
//                             >
//                                 Find Your Perfect Match!
//                             </Typography>
//                             <Typography
//                                 mb={3}
//                                 fontWeight={"400"}
//                                 fontSize={"16px"}
//                                 lineHeight={"24px"}
//                                 textAlign="justify"
//                                 color="#FFFFFF"
//                             >
//                                 Whether you're looking to secure a mortgage, refinance your home, or explore loan options, our user-friendly tool allows you to connect with Mortgage Loan Officers (MLOs) conveniently located in your area.
//                             </Typography>
//                             <Button
//                                 onClick={() => {
//                                     // router.push("/");
//                                 }}
//                                 variant="contained"
//                                 sx={{
//                                     width: "241px",
//                                     height: "48px",
//                                     mx: "10px",
//                                     borderColor: "#FFFFFF",
//                                     borderWidth: "1px",
//                                     borderStyle: "solid",
//                                     "& .MuiButton-label": {
//                                         fontWeight: 700,
//                                         fontSize: "18px",
//                                         lineHeight: "23.44px",
//                                         letterSpacing: "5%",
//                                         textAlign: "center",
//                                         textTransform: "none"
//                                     }
//                                 }}
//                             >
//                                 <Typography variant="body1">Search MLO</Typography>
//                             </Button>
//                         </Grid>
//                     </Grid>
//                 </Box>
//             </Grid>
//         </Grid>
//     );
// }


import React from 'react';
import { Box, Button, Grid, Typography } from "@mui/material";
import MloSearchLady from "../../assets/borrower-page/MLOSearchLady.svg";
import SearchGirl2 from "../../assets/borrower-page/SearchGirl2.svg";
import { useNavigate } from "react-router-dom";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from "@mui/material";

export default function SearchMLO() {
    const router = useNavigate();


    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    return (
        <Grid container justifyContent="center" spacing={0}>
            <Grid item xs={11} md={11} lg={11} sx={{ ml: { xs: 0, md: 0 }, mr: { xs: 1, md: 1 } }}>
                {/* <Box
                    sx={{
                        backgroundImage: `url(${MloSearchLady})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'contain',
                        backgroundPosition: 'center',
                        minHeight: { xs: '25vh', md: '100vh' },
                        display: 'flex',
                        alignItems: 'center',
                        px: { xs: '2rem', md: '6rem' },
                        py: { xs: '2rem', md: '6rem' },
                        color: '#FFFFFF'
                    }}
                >
                    <Grid container justifyContent="flex-end" alignItems="center">
                        <Grid
                            item
                            xs={6}
                            md={6}
                            mb={{ xs: 1, md: 0 }}
                            textAlign={{ xs: "left", md: "left" }}
                        >
                            <Typography
                                mb={{ xs: 0, md: 0 }}
                                //    mt={{ xs: 0 }}
                                fontWeight={700}
                                fontSize={{ xs: 8, md: 32 }}
                                lineHeight={{ xs: "16px", md: "48px" }}
                                color="#FFFFFF"
                            >
                                Searching for MLOs Near You?
                            </Typography>
                            <Typography
                                mb={{ xs: 0, md: 2 }}
                                fontWeight={700}
                                fontSize={{ xs: 8, md: 32 }}
                                lineHeight={{ xs: "16px", md: "48px" }}
                                color="#FFFFFF"
                            >
                                Find Your Perfect Match!
                            </Typography>
                            <Typography
                                mb={{ xs: 1, md: 3 }}
                                fontWeight={400}
                                fontSize={{ xs: 4, md: 16 }}
                                lineHeight={{ xs: "8px", md: "24px" }}
                                textAlign="justify"
                                color="#FFFFFF"
                            >
                                Whether you're looking to secure a mortgage, refinance your home, or explore loan options, our user-friendly tool allows you to connect with Mortgage Loan Officers (MLOs) conveniently located in your area.
                            </Typography>
                            <Button
                                onClick={() => {
                                    router('/borrower-portal/search');
                                }}
                                variant="contained"
                                sx={{
                                    width: { xs: "80px", md: "241px" },
                                    height: { xs: "16px", md: "48px" },
                                    mx: { xs: "3px", md: "10px" },
                                    // mt: { xs: 0, md: 0 },
                                    borderColor: "#FFFFFF",
                                    borderWidth: "1px",
                                    borderStyle: "solid",
                                    "& .MuiButton-label": {
                                        fontWeight: 700,
                                        fontSize: { xs: "6px", md: "18px" },
                                        lineHeight: { xs: "8px", md: "23.44px" },
                                        letterSpacing: { xs: "2%", md: "5%" },
                                        textAlign: "center",
                                        textTransform: "none"
                                    }
                                }}
                            >
                                <Typography sx={{ fontSize: { xs: '6px', md: '18px' } }}>Search MLO</Typography>


                            </Button>
                        </Grid>
                    </Grid>
                </Box> */}

                {/* <Grid container

                    mb={4}
                >




                    <Grid item xs={12} md={6}
                        sx={{ padding: 0, margin: 0 }}>


                        <img src={SearchGirl2} style={{ width: "100%" }} alt="Background" />

                    </Grid>
                    <Grid item xs={12} md={6} sx={{ padding: 0, margin: 0 }}>
                        <Box
                            xs={12}
                            md={6}
                            paddingBottom={{ xs: 4, md: 8 }}
                            paddingTop={{ xs: 4, md: 10 }}
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            px={{ md: 6, xs: 1 }}
                            sx={{ backgroundColor: '#31B9B5', color: 'white' }}
                            paddingLeft={{ xs: 4 }}
                            paddingRight={{ xs: 4 }}
                            marginLeft={{ xs: 0.5, md: 0 }}


                        >
                            <Typography
                                fontWeight={700}
                                fontSize={{ xs: 12, md: 32 }}
                                lineHeight={{ xs: '16px', md: '48px' }}
                                mb={{ xs: 0, md: 0 }}
                            >
                                Searching for MLOs Near You?
                            </Typography>
                            <Typography
                                fontWeight={700}
                                fontSize={{ xs: 12, md: 32 }}
                                lineHeight={{ xs: '16px', md: '48px' }}
                                mb={{ xs: 1, md: 2 }}
                            >
                                Find Your Perfect Match!
                            </Typography>
                            <Typography
                                fontWeight={400}
                                fontSize={{ xs: 8, md: 16 }}
                                lineHeight={{ xs: '12px', md: '24px' }}
                                textAlign="justify"
                                mb={{ xs: 2, md: 3 }}
                            >
                                Whether you're looking to secure a mortgage, refinance your home, or explore loan options, our user-friendly tool allows you to connect with Mortgage Loan Officers (MLOs) conveniently located in your area.
                            </Typography>
                            <Button
                                onClick={() => {
                                    router('/borrower-portal/search');
                                }}
                                variant="contained"
                                sx={{
                                    width: { xs: '80px', md: '241px' },
                                    height: { xs: '24px', md: '48px' },
                                    //  mt: { xs: 0, md: 0 },
                                    borderColor: '#FFFFFF',
                                    borderWidth: '1px',
                                    borderStyle: 'solid',
                                    '& .MuiButton-label': {
                                        fontWeight: 700,
                                        fontSize: { xs: '6px', md: '18px' },
                                        lineHeight: { xs: '8px', md: '23.44px' },
                                        textAlign: 'center',
                                        textTransform: 'none',
                                    },
                                }}
                            >
                                <Typography sx={{ fontSize: { xs: '6px', md: '18px' } }}>Search MLO</Typography>
                            </Button>
                        </Box>

                    </Grid>

                </Grid> */}
                <Grid container mb={4} sx={{ height: '100%' }}>
                    <Grid item xs={12} md={6} sx={{ padding: 0, margin: 0, display: 'flex' }}>
                        <img src={SearchGirl2} style={{ width: "100%", height: '100%', objectFit: 'cover' }} alt="Search MLO" />
                    </Grid>
                    <Grid item xs={12} md={6} sx={{ padding: 0, margin: 0, display: 'flex', alignItems: 'center' }}>
                        <Box
                            sx={{
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                backgroundColor: '#31B9B5',
                                color: 'white',
                                padding: { xs: 2, md: 9 },
                                boxSizing: 'border-box',

                            }}
                        //paddingLeft={{ xs: 8 }}
                        >
                            <Typography
                                fontWeight={700}
                                fontSize={{ xs: 16, md: 32 }}
                                lineHeight={{ xs: '20px', md: '48px' }}
                                mb={{ xs: 1, md: 0 }}
                            >
                                Searching for MLOs Near You?
                            </Typography>
                            <Typography
                                fontWeight={700}
                                fontSize={{ xs: 16, md: 32 }}
                                lineHeight={{ xs: '20px', md: '48px' }}
                                mb={{ xs: 1, md: 2 }}
                            >
                                Find Your Perfect Match!
                            </Typography>
                            <Typography
                                fontWeight={400}
                                fontSize={{ xs: 12, md: 16 }}
                                lineHeight={{ xs: '16px', md: '24px' }}
                                textAlign="justify"
                                mb={{ xs: 2, md: 3 }}
                            >
                                Whether you're looking to secure a mortgage, refinance your home, or explore loan options, our user-friendly tool allows you to connect with Mortgage Loan Officers (MLOs) conveniently located in your area.
                            </Typography>
                            <Button
                                onClick={() => {
                                    router('/borrower-portal/search');
                                }}
                                variant="contained"
                                sx={{
                                    width: { xs: '100px', md: '241px' },
                                    height: { xs: '32px', md: '48px' },
                                    borderColor: '#FFFFFF',
                                    borderWidth: '1px',
                                    borderStyle: 'solid',
                                    '& .MuiButton-label': {
                                        fontWeight: 700,
                                        fontSize: { xs: '12px', md: '18px' },
                                        lineHeight: { xs: '16px', md: '23.44px' },
                                        textAlign: 'center',
                                        textTransform: 'none',
                                    },
                                }}
                            >
                                <Typography sx={{ fontSize: { xs: '12px', md: '18px' } }}>Search MLO</Typography>
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
                {/* <Grid container mb={4} sx={{ height: '50vh' }}>
                    <Grid item xs={12} md={6} sx={{ padding: 0, margin: 0, display: 'flex' }}>
                        <Box sx={{ width: '100%', height: '100%', display: 'flex' }}>
                            <img src={SearchGirl2} style={{ width: "100%", height: '100%', objectFit: 'cover' }} alt="Background" />
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={6} sx={{ padding: 0, margin: 0, display: 'flex' }}>
                        <Box
                            sx={{
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                backgroundColor: '#31B9B5',
                                color: 'white',
                                padding: { xs: 2, md: 6 },
                                boxSizing: 'border-box',
                            }}
                        >
                            <Typography
                                fontWeight={700}
                                fontSize={{ xs: 16, md: 32 }}
                                lineHeight={{ xs: '20px', md: '48px' }}
                                mb={{ xs: 1, md: 2 }}
                            >
                                Searching for MLOs Near You?
                            </Typography>
                            <Typography
                                fontWeight={700}
                                fontSize={{ xs: 16, md: 32 }}
                                lineHeight={{ xs: '20px', md: '48px' }}
                                mb={{ xs: 1, md: 2 }}
                            >
                                Find Your Perfect Match!
                            </Typography>
                            <Typography
                                fontWeight={400}
                                fontSize={{ xs: 12, md: 16 }}
                                lineHeight={{ xs: '16px', md: '24px' }}
                                textAlign="justify"
                                mb={{ xs: 2, md: 3 }}
                            >
                                Whether you're looking to secure a mortgage, refinance your home, or explore loan options, our user-friendly tool allows you to connect with Mortgage Loan Officers (MLOs) conveniently located in your area.
                            </Typography>
                            <Button
                                onClick={() => {
                                    router('/borrower-portal/search');
                                }}
                                variant="contained"
                                sx={{
                                    width: { xs: '100px', md: '241px' },
                                    height: { xs: '32px', md: '48px' },
                                    borderColor: '#FFFFFF',
                                    borderWidth: '1px',
                                    borderStyle: 'solid',
                                    fontWeight: 700,
                                    fontSize: { xs: '12px', md: '18px' },
                                    lineHeight: { xs: '16px', md: '23.44px' },
                                    textAlign: 'center',
                                    textTransform: 'none',
                                }}
                            >
                                Search MLO
                            </Button>
                        </Box>
                    </Grid>
                </Grid> */}
            </Grid >
        </Grid >

    );
}
